import React from 'react';
import { HERO_MOCKUP_IMAGE } from '../../data/site';
export function HeroMockup() {
  return <figure className="mx-auto w-full max-w-[340px] sm:max-w-[480px] lg:max-w-[580px]" data-id="element-128" data-mp="q0khnlo67pp2">
      <img src={HERO_MOCKUP_IMAGE} alt="Handball Class Ready digital teaching pack: 12 ready-to-teach lessons plus 5 bonus resources, shown as a box set" fetchPriority="high" className="block h-auto w-full drop-shadow-[0_24px_36px_rgba(0,0,0,0.55)]" data-id="element-129" data-mp="c8w55ha0ez7k" />
      <figcaption className="mt-3 text-center text-xs text-white/65 sm:text-sm" data-id="element-130" data-mp="79jj2yqypw61">
        Digital PDF pack · Illustrative mockup · Nothing shipped
      </figcaption>
    </figure>;
}